import { GroupOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function ExamCenterMemberListNoRowsOverlay() {
  return <NoRowsOverlay icon={GroupOutlinedIcon} title='ยังไม่มีสมาชิก' />;
}
